import { ReactNode } from 'react';
import { CapaNotification, CapaNotificationType } from '@generated/graphql';

const getNotificationContent = (
  notification: CapaNotification
): null | {
  color: 'primary' | 'error';
  title: string | ReactNode;
  content: string | ReactNode;
} => {
  const notificationType = notification.data?.notificationType;

  if (!notificationType) return null;

  switch (notificationType) {
    case CapaNotificationType.PurchaseOrderRegisterRequest:
      return {
        color: 'primary',
        title: '파트너가 발주서 발행 요청을 보냈습니다',
        content: '견적서를 확인하고 발주를 진행하세요.'
      };

    case CapaNotificationType.AwaitingPayment:
      return {
        color: 'primary',
        title: '입금 대기중인 프로젝트가 있습니다.',
        content:
          '파트너가 제조를 시작할 수 있도록 캐파 가상계좌로 결제대금을 입금해주세요.'
      };

    case CapaNotificationType.RejectRfqPurchaseOrderCreditCard:
    case CapaNotificationType.RejectRfqPurchaseOrderVirtualAccount:
      return {
        color: 'error',
        title: '파트너가 발주서를 거부했습니다.',
        content:
          '프로젝트가 결제/발주 단계에서 중단됩니다. 해당 발주서의 결제대금은 자동 환불됩니다.'
      };

    case CapaNotificationType.CancelConfirmedCreditCard:
    case CapaNotificationType.CancelConfirmedVirtualAccount:
      return {
        color: 'error',
        title: '결제취소가 완료되었습니다.',
        content:
          '프로젝트가 결제/발주 단계에서 중단됩니다. 해당 발주서의 결제대금은 자동 환불됩니다.'
      };

    case CapaNotificationType.NotPaidCanceled:
      return {
        color: 'error',
        title: '입금 기간이 만료되었습니다.',
        content:
          '프로젝트가 결제/발주 단계에서 중단됩니다. 거래를 계속 진행하고 싶다면 파트너에게 발주서를 재발행하세요.'
      };

    case CapaNotificationType.StartProcessing:
      return {
        color: 'primary',
        title: '파트너가 제조를 시작했습니다.',
        content: '제조가 완료되면 파트너가 배송을 시작합니다.'
      };

    case CapaNotificationType.RefundConfirmedCreditCard:
    case CapaNotificationType.RefundConfirmedVirtualAccount:
      return {
        color: 'error',
        title: '환불이 완료되었습니다.',
        content:
          '프로젝트가 제조 단계에서 중단됩니다. 해당 발주서의 결제대금은 고객님께 자동 환불됩니다.'
      };

    case CapaNotificationType.StartShipping:
      return {
        color: 'primary',
        title: '배송이 시작되었습니다.',
        content:
          '파트너가 제조를 마치고 배송을 시작했습니다. 검품 후 이상이 없다면 구매확정해주세요.'
      };

    case CapaNotificationType.InduceConfirmPurchase:
      return {
        color: 'primary',
        title: '구매확정 대기중입니다.',
        content: '제품 검품 후 이상이 없다면 구매확정하여 거래를 완료해주세요.'
      };

    case CapaNotificationType.PurchaseConfirmed:
      return {
        color: 'primary',
        title: '거래가 완료되었습니다.',
        content: `파트너와의 거래는 어떠셨나요? 고객님의 소중한 후기를 작성해주세요.`
      };

    default:
      return null;
  }
};

export default getNotificationContent;
